"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _freeBrandsSvgIcons = require("@fortawesome/free-brands-svg-icons");
var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");
var _themeFactory = _interopRequireDefault(require("../theme/themeFactory"));
var _helpers = require("../utilities/helpers");
require("../icons");
const _excluded = ["children", "theme", "type", "parent"];
_fontawesomeSvgCore.library.add(_freeBrandsSvgIcons.fab, _freeRegularSvgIcons.far, _freeSolidSvgIcons.fas);
const ThemeProvider = _ref => {
  let {
      children,
      theme,
      type,
      parent
    } = _ref,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_styles.MuiThemeProvider, (0, _extends2.default)({}, rest, {
    theme: parent ? (0, _themeFactory.default)(type, theme) : currentTheme => (0, _themeFactory.default)(currentTheme.type, (0, _helpers.deepmerge)(currentTheme, theme))
  }), children);
};
ThemeProvider.propTypes = {
  children: _propTypes.default.node,
  theme: _propTypes.default.object,
  type: _propTypes.default.string,
  parent: _propTypes.default.bool
};
ThemeProvider.defaultProps = {
  children: null,
  theme: {},
  type: 'light',
  parent: false
};
var _default = exports.default = ThemeProvider;